<template>
  <q-dialog
    content-class="__dialog"
    v-model="currentVisible"
    :persistent="persistent"
    @before-show="$emit('before-open')"
    @show="$emit('open')"
    @before-hide="$emit('before-hide')"
    @hide="$emit('close')"
  >
    <q-card class="content" :style="{ width: width, 'max-width': '80vw' }">
      <Loading :loading="loading || inProgress" :text="inProgress ? progressText : ''" />

      <q-card-section class="row items-center">
        <div class="text-h6" v-if="title">{{ title }}</div>
        <q-space />
        <q-btn
          icon="close"
          flat
          round
          dense
          v-close-popup
          @click="$emit('close')"
          v-if="closeable"
        />
      </q-card-section>

      <q-card-section>
        <slot />
      </q-card-section>

      <q-card-actions align="right" class="mt-md mb-sm">
        <CButton
          class="mr-sm"
          color="standard"
          :label="$t('Cancel')"
          @click="$emit('cancel')"
          v-close-popup
          v-if="submittable"
        />
        <CButton
          class="submit-btn"
          :type="submittable ? 'submit' : 'button'"
          :color="submitBtnType"
          :label="submitLabel"
          :disable="submitDisabled"
          :loading="submitLoading"
          @click="handleSubmit"
          v-if="submittable"
        />
        <CButton :label="$t('Close')" @click="$emit('close')" v-close-popup v-else />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import CButton from '@/components/uikit/CButton';
import Loading from '@/components/uikit/Loading';

export default {
  name: 'Dialog',
  components: { CButton, Loading },
  props: {
    // Supported .sync
    visible: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    inProgress: {
      type: Boolean,
      default: false,
    },

    title: {
      type: [String, Number],
    },

    submittable: {
      type: Boolean,
      default: false,
    },

    submitLabel: {
      type: String,
      default: 'OK',
    },

    submitBtnType: {
      type: String,
      default: 'primary',
    },

    submitDisabled: {
      type: Boolean,
      default: false,
    },

    submitLoading: {
      type: Boolean,
    },

    progressMsg: {
      type: String,
    },

    progressType: {
      type: String,
      default: 'set',
    },

    persistent: {
      type: Boolean,
      default: false,
    },

    closeable: {
      type: Boolean,
      default: true,
    },

    width: {
      type: String,
    },
  },
  data() {
    return {
      progress: false,
    };
  },
  computed: {
    currentVisible: {
      set(value) {
        this.$emit('update:visible', value);
      },
      get() {
        return this.visible;
      },
    },

    progressText() {
      if (this.progressMsg) return this.progressMsg;

      switch (this.progressType) {
        case 'set':
          return this.$t('Setting...');
        case 'update':
          return this.$t('Updating...');
        case 'create':
          return this.$t('Creating...');
        case 'generate':
          return this.$t('Generating...');
        case 'delete':
          return this.$t('Deleting...');
        case 'remove':
          return this.$t('Removing...');
        case 'check':
          return this.$t('Checking...');
        default:
          return '';
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit');
    },

    isProgress() {
      this.progress = true;
    },

    isDone() {
      setTimeout(() => {
        this.progress = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
$information-width: 450px;
$information-height: 450px;

.__dialog {
  position: relative;

  .content {
    min-width: 400px;

    &.information {
      width: $information-width;
      height: $information-height;
    }
  }

  .submit-btn {
    margin-right: 8px;
  }
}
</style>
